import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Testimonials from "@/components/Testimonials";
import ServicesPage from "@/pages/ServicesPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import QuotePage from "@/pages/QuotePage";
import AdminLogin from "@/pages/AdminLogin";
import LocalServicePage from "@/pages/LocalServicePage";
import FaqPage from "@/pages/FaqPage";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/context/AuthContext";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Portfolio from "@/components/Portfolio";
import CaseStudies from "@/components/CaseStudies";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import ErrorBoundary from "@/components/ErrorBoundary";
import MonitoringDashboard from "@/components/MonitoringDashboard";
import AdminDashboard from "@/components/AdminDashboard";
import EvergreenBanner from "@/components/EvergreenBanner";
import ChatBot from "@/components/ChatBot";
import { Toaster } from "@/components/ui/sonner";
import { useHealthCheck } from "@/hooks/useMonitoring";

const HEALTH_CHECK_INTERVAL_MS = 60000; // 1 minute

const Home = () => {
  // Monitor backend health periodically
  useHealthCheck(HEALTH_CHECK_INTERVAL_MS);

  const location = useLocation();

  useEffect(() => {
    const target = location.state?.scrollTo;
    if (!target) return;
    const timer = setTimeout(() => {
      document.getElementById(target)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 150);
    return () => clearTimeout(timer);
  }, [location.state]);

  return (
    <div className="min-h-screen">
      <EvergreenBanner />
      <Header />
      <main>
        <Hero />
        <Services />
        <Portfolio />
        <CaseStudies />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <ChatBot />
      <Toaster position="top-right" />
    </div>
  );
};

function App() {
  return (
    <ErrorBoundary>
      <div className="App">
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/services/:slug" element={<ServiceDetailPage />} />
              <Route path="/quote" element={<QuotePage />} />
              <Route path="/faq" element={<FaqPage />} />
              <Route path="/local/:slug" element={<LocalServicePage />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/monitoring" element={<ProtectedRoute><MonitoringDashboard /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </div>
    </ErrorBoundary>
  );
}

export default App;
